import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { SplashscreenComponent } from './splashscreen/splashscreen.component';
import { SSOID_LOGIN_PATH } from './constants/paths';

const routes: Routes = [
  {
    path: 'pages',
    loadChildren: () => import('src/app/pages/pages.module').then((m) => m.PagesModule),
  },
  {
    path: 'splashscreen',
    component: SplashscreenComponent,
  },
  {
    path: SSOID_LOGIN_PATH,
    loadChildren: () => import('src/app/login-email/login-email.module').then((m) => m.LoginEmailModule),
  },
  { path: '', redirectTo: 'splashscreen', pathMatch: 'full' },
  { path: '**', redirectTo: 'splashscreen' },
];

const config: ExtraOptions = {
  useHash: true,
  relativeLinkResolution: 'legacy',
};

@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
